export default __webpack_public_path__ + "static/media/goopter-ecommerce-customer-reviews.254f6a5f.png";